import { useState, useEffect } from "react";
import "./Kiemtra.css";
import {Link, useNavigate } from "react-router-dom";
import { loginCustomer } from "./../services/Api";
import { jwtDecode } from "jwt-decode";

const Kiemtra = () => {
  const [formInputs, setFormInputs] = useState({});
  const [errorLogin, setErrorLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const changeFormInputs = (e) => {
    const { name, value } = e.target;
    setFormInputs({ ...formInputs, [name]: value });
    // Clear error khi user bắt đầu nhập lại
    if (errorLogin) setErrorLogin(false);
  };

  const clickLogin = (e) => {    
    //tạo popup "vui lòng đợi"
    setIsLoading(true);
    loginCustomer(formInputs)
      .then(({ data }) => {
        // console.log(data);
        //lưu vào localStorage
        localStorage.setItem("accessToken", data.accessToken);
        return navigate("/db34tinh");
      })
      .catch((error) => {
        // console.log(error);
        if (error.response.data === "Email not valid") {
          return setErrorLogin("Email không hợp lệ!");
        }
        if (error.response.data === "Password not valid") {
          return setErrorLogin("Password không hợp lệ!");
        }
        return console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    const readAccessToken = localStorage.getItem("accessToken");
    if (readAccessToken) {
      const checkExpired = jwtDecode(readAccessToken);
      if (checkExpired.exp < new Date() / 1000){
        localStorage.removeItem("accessToken");
        localStorage.clear();
      } else {
        return navigate("/db34tinh");
      }
    }
  }, []);
  return (
    <>
      {/*	Login Form	*/}
      <div id="customer">
        {errorLogin && (
          <div className="alert alert-danger text-center">
            {errorLogin}
          </div>
        )}
        <h3 className="text-center">Đăng nhập</h3>
        <form method="post">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div id="customer-mail" class="custom-field">
                  <input
                    onChange={changeFormInputs}
                    placeholder="Email (bắt buộc)"
                    type="text"
                    name="email"
                    className="form-control"
                    required
                  />
              </div> 
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12">
              <div id="customer-pass" class="custom-field">
                  <input
                      onChange={changeFormInputs}
                      placeholder="Mật khẩu (bắt buộc)"
                      type="password"
                      name="password"
                      className="form-control"
                      required
                    />
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="by-now col-lg-12 col-md-12 col-sm-12">
            <Link onClick={clickLogin} to="#">
              <b>Đăng nhập ngay</b>
            </Link>
          </div>
          </div>
        </form>
      </div>
      {/*	End Login Form	*/}
      {/* Popup loading */}
      {isLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'white',
            padding: '20px 40px',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            gap: '15px'
          }}>
            <div style={{
              width: '24px',
              height: '24px',
              border: '3px solid #f3f3f3',
              borderTop: '3px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            <span>Vui lòng đợi...</span>
          </div>
        </div>
      )}    
    </>
  );
};

export default Kiemtra;